import * as t from 'io-ts';

import {makeApiType} from './apiTypes';

/*
 * Runtime type.
 */

export const RConversationInteractions = t.readonly(
  t.type({
    numInteractions: t.number,
    numMessagesSent: t.number,
    numMessagesReceived: t.number,
    numComments: t.number,
  }),
);

/*
 * Type.
 */

export interface ConversationInteractionsModel extends t.TypeOf<typeof RConversationInteractions> {}

/*
 * IO methods.
 */

export function parseConversationInteractions(src: any): ConversationInteractionsModel {
  return {
    numInteractions: src.num_interactions,
    numMessagesSent: src.num_messages_sent,
    numMessagesReceived: src.num_messages_received,
    numComments: src.num_comments,
  };
}

/*
 * API type.
 */

export const ApiConversationInteractions = makeApiType(
  'ConversationInteractions',
  RConversationInteractions,
  parseConversationInteractions,
);
